export const RINGBA_TAG = { tag: "", value: null, type: "", id: "" };

export const RINGBA_TAG_VALUES = [
  { text: "true", value: true },
  { text: "false", value: false },
  { text: "53", value: 53 },
  { text: "65", value: 65 },
  { text: "86", value: 86 },
];

export const AUDIO_FILE = {
  fileID: "",
  fileURL: "",
  fileName: "",
};

export const MESSAGE = {
  messageType: "message",
  content: "",
  backgroundColor: "",
  delay: 2000,
  human: false,
  cssClass: "",
  hasRingbaScript: false,
  ringbaScript: "",
  children: [],
  hideBackground: false,
  hideLoader: false,
  fullWidth: false,
  audio: { ...AUDIO_FILE },
  isLastMessage: false,
  next: null,
};

export const DEFAULT_QUESTION = {
  messageType: "defaultQuestion",
  content: "",
  delay: 2000,
  children: [],
  defaultQuestionType: "",
};

export const FLOATING_TEXT = {
  enabled: false,
  text: "",
  animation: "none",
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
};

export const FLOATING_TEXT_ANIMATIONS = [
  { text: "None", value: "none" },
  { text: "Bounce", value: "bounce" },
  { text: "Pulse", value: "pulse" },
  { text: "Fade", value: "fade" },
  { text: "Wiggle", value: "wiggle" },
];

export const ACTION = {
  messageType: "action",
  delay: 2000,
  cssClass: "",
  backgroundColor: "",
  children: [],
  columns: null,
  floatingText: { ...FLOATING_TEXT },
};

export const ACTION_ITEM = {
  messageType: "actionItem",
  text: "",
  backgroundColor: "",
  value: "",
  hasRingbaScript: false,
  ringbaScript: "",
  ringbaTags: [],
  children: [],
  audio: { ...AUDIO_FILE },
  next: null,
};

export const INPUT_QUESTION = {
  messageType: "inputQuestion",
  delay: 2000,
  content: "",
  children: [],
  inputQuestionType: "",
  inputQuestionDisplayType: "",
  buttonText: "Confirm",
  buttonColor: "",
  displayUserAnswer: false,
  floatingText: { ...FLOATING_TEXT },
};

export const DECISION = {
  messageType: "decision",
  children: [],
  ringbaTags: [],
  greaterThan: null,
  greaterThanOrEqual: null,
  lessThan: null,
  lessThanOrEqual: null,
  next: null,
};

export const LIVE_CHAT_THEME = [
  { text: "iMessage", value: "imessage" },
  { text: "Messenger", value: "messenger" },
];

export const INPUT_QUESTION_DISPLAY_TYPES = [
  {
    value: "years",
    text: "Years (ex. 1959)",
  },
  {
    value: "age",
    text: "Age (ex. 60)",
  },
];

export const ZIP_INPUT_QUESTION = {
  messageType: "zipInputQuestion",
  delay: 2000,
  content: "",
  children: [],
  zipInputDisplayType: "",
  buttonText: "Confirm",
  buttonColor: "",
  placeholderText: "e.g., 12345",
  overrideZipOnly: true,
  overrideZipAndLocation: false,
  floatingText: { ...FLOATING_TEXT },
};

export const ZIP_INPUT_DISPLAY_TYPES = [
  {
    value: "empty",
    text: "Empty input",
  },
  {
    value: "prefilled",
    text: "Pre-filled input",
  },
];

export const ZIP_OVERRIDE_MODE = {
  ZIP_ONLY: "zipOnly",
  ZIP_AND_LOCATION: "zipAndLocation",
};
